import { PropsWithChildren, ReactElement } from "react";

import { SVG_MUI } from "@ryde/assets";

import { ModalHeaderStyled } from "./modal.styled";

interface IModalHeaderProps extends PropsWithChildren {
  onClose: () => void;
}

export const ModalHeader = ({
  children,
  onClose,
}: IModalHeaderProps): ReactElement => {
  return (
    <ModalHeaderStyled>
      <h2 className="title">{children}</h2>
      <SVG_MUI.XMarkSVG onClick={onClose} />
    </ModalHeaderStyled>
  );
};
